<template lang="pug">
  .giftKeepsGiving
    .text-block.one(data-animate="true")
      h4 How many people prefer buy-online-pick-up-in-store?
      p Retailers with both physical and online stores saw a <span class="bold">50% uptick</span> in the usage of BOPIS.<span class="super"><a href="https://cmo.adobe.com/articles/2019/1/5-holiday-online-shopping-trends-to-guide-your-2019-strategy.html" target="_blank">5</a></span>
    .text-block.two(data-animate="true")
      h4 How many people purchase gifts at the last minute? What do they buy?<span class="super">11</span>
      .number.small 70%
      p Proportion of gift card sales that are electronic on December 25; physical cards are preferred 90% of the time except for this last-minute occasion.
      .number.small 1.5X
      p Increase in spend by procrastinators who shop for last-minute beauty, retail, or entertainment gift cards.
      .number.small $50
      p The peak median value gift cards soar to in the days before Christmas.
    .text-block.three#giving
      h2 The Gift That Keeps on Giving
    .text-block.three-and-half(data-animate="true")
      p Despite shoppers’ best intentions, many unwanted gifts will be under the tree this year. But rather than considering it a hassle, retailers are embracing the upsell opportunities they can realize by making returns seamless. That’s because shoppers aren’t done spending yet: Many will have holiday cash or gift cards burning a hole in their pockets as they take advantage of post-holiday markdowns and hit the sales both in stores and online. 
    .text-block.four(data-animate="true")
      h4 Do people look for deals after the holidays?
      .text-block-small.left
        .number.small 50%
        p of consumers who miss Christmas deadlines plan to take advantage of after-Christmas sales in stores.
        .number.small 45%
        p plan to do the same online.<span class="super"><a href="https://nrf.com/media-center/press-releases/procrastinators-rush-meet-holiday-deadline" target="_blank">13</a></span>
      .text-block-small.right
        .number.small 51%
        p will shop after Christmas to take advantage of post-holiday sales.
        .number.small 27%
        p will shop to use gift cards they receive.
        .number.small 17%
        p will return and exchange unwanted gifts.<span class="super"><a href="https://nrf.com/media-center/press-releases/procrastinators-rush-meet-holiday-deadline" target="_blank">13</a></span>
    GiftImg.desktop
    GiftImgMobile.mobile
</template>

<script>
import GiftImg from '@/assets/img/svgs/giftkeepsgiving.svg'
import GiftImgMobile from '@/assets/img/svgs/giftKeepsGivingMobile.svg'
import AnimationManager from '../scripts/AnimationManager'

export default {
  name: 'giftKeepsGiving',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
    const starMobile = this.$el.querySelectorAll('.starMobile')
    const stars = this.$el.querySelectorAll('.star')
    console.log(stars)

    starMobile.forEach((star, i) => {
      const timeline = new TimelineLite({ paused: true })
        .from(star, .5, { transformOrigin: '50% 50%', opacity: 0, scale: .85, rotation: i%2 === 0 ? 30 : -30 }, '-=0.75')
      AnimationManager.onEnterView(star, () => {
        timeline.seek(0)
        timeline.play()
      })
    })

    stars.forEach((star, i) => {
      const timeline = new TimelineLite({ paused: true })
        .from(star, .5, { transformOrigin: '50% 50%', opacity: 0, scale: .85, rotation: i%2 === 0 ? 30 : -30 }, '-=0.75')
      AnimationManager.onEnterView(star, () => {
        timeline.seek(0)
        timeline.play()
      })
    })
  },
  computed: {
  },
  methods: {
  },
  components: {
    GiftImg,
    GiftImgMobile,
  },
}
</script>

<style scoped lang="scss">
.giftKeepsGiving {
  position: relative;
  padding-left: 10%;
  padding-top: 1rem;

  .text-block {
    &.one {
      width: 29%;
      left: 23%;
      top: 4%;
      h4 {
        width: 83%;
      }
    }
    &.two {
      top: 4%;
      width: 31%;
      right: 11%;
      p {
        &:nth-of-type(1) {
          width: 72%;
        }
        &:nth-of-type(2) {
          width: 80%;
        }
        &:nth-of-type(3) {
          width: 80%;
        }
      }
    }
    &.three {
      left: 18%;
      top: 37%;
      width: 31%;
      padding-top: 5rem; 
      h2 {
        padding-bottom: 3rem;
      }
    }

    &.three-and-half {
      top: 42%;
      left: 18%;
      width: 31%;
      padding-top: 5rem; 
    }

    &.four {
      left: 46%;
      bottom: 11%;
      width: 41%;
      h4 {
        max-width: 62%;
      }
    }
  }

  h4 {
    color: #000;
  }

  .text-block-small {
    display: inline-block;
    vertical-align: top;
    width: calc(50% - 1.5%); 
    &:first-of-type {
      padding-right: 3%;
    }
  }

  @media #{$mobile} {
    padding: 7rem 7rem 0 0;

    .text-block {
      &.one {
        width: 42%;
        left: auto;
        left: 52%;
        top: 2%;
      }
      &.two {
        top: 9%;
        width: 42%;
        left: 52%;
        h4 {
          margin-bottom: 3rem;
        }
        p {
          &:nth-of-type(1) {
            width: 85%;
          }
          &:nth-of-type(2) {
            width: 80%;
          }
          &:nth-of-type(3) {
            width: 80%;
          }
        }
      }
      &.three {
        text-align: center;
        width: 100%;
        padding-top: 5rem;
        top: 32%;
        left: 0;
        h2 {
          padding-bottom: 3rem;
        }
      }

      &.three-and-half {
        top: 50%;
        width: 80%;
        left: 10%;
        text-align: center;
      }

      &.four {
        left: 20%;
        bottom: auto;
        top: 62%;
        width: 60%;
        text-align: center;
        h4 {
          max-width: 56%;
          margin: 0 auto;
        }
      }

      .text-block-small {
        display: block;
        width: 100%;
        padding: 0;
        &:first-of-type {
          padding-right: 0;
          padding-top: 3rem;
        }
      }
    }
  }
}
</style>
